var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-page"},[_c('i',{staticClass:"el-icon-warning"}),_vm._v(" 无权限访问 ")])
}]

export { render, staticRenderFns }